// Helper function to wait for form to exist
function waitForForm(selector, callback, retries = 10, delay = 100) {
  const form = document.querySelector(selector);
  if (form) {
    callback(form);
  } else if (retries > 0) {
    setTimeout(
      () => waitForForm(selector, callback, retries - 1, delay),
      delay
    );
  }
}

// Function to initialize dynamic population logic
function initializeDynamicPopulation(form, isEditMode) {
  const productCollectionField = form.querySelector("#input_6_4");
  const productField = form.querySelector("#input_6_6");
  let productSeatsField = form.querySelector("#input_6_7");
  const spifId = new URLSearchParams(window.location.search).get("promo_id");

  if (!productCollectionField || !productField || !productSeatsField) return;

  // Add placeholder to the Product Collection dropdown
  if (!productCollectionField.querySelector('option[value=""]')) {
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.textContent = "-- Select a Collection --";
    placeholderOption.selected = true;
    productCollectionField.insertBefore(
      placeholderOption,
      productCollectionField.firstChild
    );
  }

  // Fetch SPIF Payout from ACF using the SPIF ID
  let spifPayout = 0;
  if (spifId) {
    fetch(ajax_object.ajax_url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        action: "get_spif_payout",
        spif_id: spifId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          spifPayout = parseFloat(data.data.payout) || 0;
        }
      });
  }

  // Event listener for Product Collection selection
  productCollectionField.addEventListener("change", function () {
    const collectionId = productCollectionField.value;
    productField.innerHTML = '<option value="">-- Select a Product --</option>';

    if (collectionId) {
      fetch(ajax_object.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "get_products_by_collection",
          collection_id: collectionId,
          promo_id: spifId,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data) && data.length > 0) {
            data.forEach((product) => {
              const option = document.createElement("option");
              option.value = product.id;
              option.textContent = product.name;
              productField.appendChild(option);
            });
          } else {
            productField.innerHTML =
              '<option value="">No products available</option>';
          }
        });
    }
  });

  // Event listener for Product selection
  productField.addEventListener("change", function () {
    const productId = productField.value;
    if (productId) {
      fetch(ajax_object.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "get_product_details",
          product_id: productId,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            productSeatsField.value = data.data.product_seats || "";

            function calculateAndSetPayout() {
              const productSeats = parseFloat(productSeatsField.value) || 0;
              const totalPayout = spifPayout * productSeats;
              const payoutInputField = form.querySelector("#input_6_8");
              if (payoutInputField) {
                payoutInputField.value = totalPayout.toFixed(2);
              }
            }

            // Calculate payout when seats are updated
            calculateAndSetPayout();
            productSeatsField.addEventListener("input", calculateAndSetPayout);
          }
        });
    }
  });
}

// Main script to handle adding products and initializing dynamic population
document.addEventListener("DOMContentLoaded", function () {
  const addProductButton = document.querySelector(".gpnf-add-entry");
  if (addProductButton) {
    addProductButton.addEventListener("click", function () {
      waitForForm("#gform_6", (form) => {
        initializeDynamicPopulation(form, false);
      });
    });
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".gpnf-row-actions .edit .edit-button")) {
      waitForForm("#gform_6", (form) => {
        initializeDynamicPopulation(form, true);
      });
    }
  });
});
